import { SortingState } from "@tanstack/react-table";
import { EnumSortDirection } from "src/components/pages/search/components/sort-direction-button/sort-direction-button";
import { ISelectedRanking } from "src/components/pages/search/components/types";
import { ISortDirectionType } from "src/types/common";

export const mapStoreSortingToTableSortingState = (selectedRanking: ISelectedRanking | null, sortDirection: ISortDirectionType): SortingState => {
    if (selectedRanking?.id == null) {
        return [];
    }

    return [{ id: selectedRanking.id, desc: sortDirection === EnumSortDirection.PointingDown }];
};
